module.exports = __webpack_public_path__ + "img/Goodstoryweb-success.25966f94.png";